import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, ChevronDown, HelpCircle } from "lucide-react";
import { COMPANY, FAQ } from "../lib/constants";
import useSeo, { breadcrumbJsonLd } from "../lib/useSeo";

export default function Faq() {
  useSeo({
    title: "FAQ Serrurier — Tarifs, délais, urgence | Mon Serrurier Breton",
    description:
      "Foire aux questions serrurerie : tarifs ouverture de porte, délais d'intervention, urgences nuit/week-end, ouverture sans casse, remboursement assurance. Toutes les réponses claires d'un artisan breton.",
    path: "/faq",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQ.map((it) => ({
          "@type": "Question",
          name: it.q,
          acceptedAnswer: { "@type": "Answer", text: it.a },
        })),
      },
      breadcrumbJsonLd([
        { name: "Accueil", path: "/" },
        { name: "FAQ", path: "/faq" },
      ]),
    ],
  });
  const [openIdx, setOpenIdx] = useState(0);
  useEffect(() => {}, []);

  return (
    <div data-testid="page-faq">
      <section className="max-w-5xl mx-auto px-4 md:px-8 pt-12 md:pt-20 pb-10">
        <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-teal-700 mb-3">
          <HelpCircle className="w-4 h-4" /> Foire aux questions
        </div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-slate-900 leading-[0.95]">
          Vos questions,
          <br />
          <span className="text-teal-600">nos réponses claires.</span>
        </h1>
        <p className="text-slate-600 mt-5 leading-relaxed max-w-2xl">
          Tarifs, délais, urgences, ouverture non destructive, remboursement
          assurance… On vous répond sans détour.
        </p>
      </section>

      <section className="max-w-5xl mx-auto px-4 md:px-8 pb-16">
        <div className="space-y-3">
          {FAQ.map((it, i) => {
            const open = openIdx === i;
            return (
              <div
                key={i}
                data-testid={`faq-item-${i + 1}`}
                className={`rounded-3xl border transition-all overflow-hidden ${
                  open
                    ? "border-teal-500 bg-white shadow-lg"
                    : "border-slate-200 bg-white"
                }`}
              >
                <button
                  data-testid={`faq-toggle-${i + 1}`}
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="w-full flex items-start justify-between gap-4 text-left p-6 md:p-7"
                  aria-expanded={open}
                >
                  <span className="flex items-start gap-4">
                    <span
                      className={`font-display font-black ${
                        open ? "text-teal-600" : "text-slate-300"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-display text-lg md:text-xl font-bold text-slate-900">
                      {it.q}
                    </span>
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 mt-1 flex-shrink-0 text-slate-500 transition-transform ${
                      open ? "rotate-180 text-teal-600" : ""
                    }`}
                  />
                </button>
                {open && (
                  <div className="px-6 md:px-7 pb-6 md:pb-7 -mt-2">
                    <div className="pl-10 text-slate-700 leading-relaxed">
                      {it.a}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 md:px-8 pb-20">
        <div className="rounded-3xl bg-gradient-to-br from-teal-700 to-slate-900 text-white p-10 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="font-display text-2xl md:text-3xl font-extrabold">
              Une autre question ?
            </h2>
            <p className="text-teal-100 mt-2">
              Appelez-nous, c'est gratuit et on répond tout de suite.
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <a
              data-testid="faq-cta-call"
              href={`tel:${COMPANY.phoneDigits}`}
              className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-full px-6 py-4 shadow-xl text-lg"
            >
              <Phone className="w-5 h-5" /> {COMPANY.phone}
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-white text-slate-900 font-bold rounded-full px-6 py-4"
            >
              Formulaire
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
